import { useEffect, useState } from 'react';
import { Accordion, Text, TextTag, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import { TechnicalInformationTable } from '@/components/technicalInformation/technicalInformationTable';
import { TechnicalDataValues } from '@org-avp/avp-hck-dga-customerui-commons';

type TechnicalDataAccordionProps = {
  name: string;
  values: TechnicalDataValues[];
  collapseAll?: boolean;
};

export const TechnicalInformationAccordion = ({
  name,
  values,
  collapseAll = false,
}: TechnicalDataAccordionProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    if (!collapseAll) {
      return;
    }
    setIsOpen(false);
  }, [collapseAll]);

  return (
    <Accordion
      data-testid="accordion"
      id={name}
      headline={
        <Text tag={TextTag.h2} appearance={TokenTextAppearance.headline200} bold>
          {name}
        </Text>
      }
      isOpen={isOpen}
      onClick={() => setIsOpen((prev) => !prev)}
    >
      <TechnicalInformationTable category={name} values={values} />
    </Accordion>
  );
};
